/* eslint-disable  @typescript-eslint/no-explicit-any */
import { IProductResponse } from "../models/Other";

export function convertProduct(data: any): IProductResponse[] {
  return data?.map((item: any) => ({
    id: item.id,
    code: item.code,
    name: item.name,
  }))
}